export function isNonNullable<T>(t: T | null): t is NonNullable<T> {
  return t != null;
}
